// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"03346f77","455":"d1fdfc4d","519":"3a397366","600":"3faf0d92","805":"7c83e3e7"}[chunkId] + ".chunk.js";
};